import React from 'react';
import CabRoute from '../CabRoute/CabRoute';
import ContentBox from '../ContentBox/ContentBox';
import RouteCarousel from '../RouteCarousel/RouteCarousel';
import BusRoute from '../BusRoute/BusRoute';
import TrainRoute from '../TrainRoute/TrainRoute';
import FlightRoute from '../FlightRoute/FlightRoute';
import { cabRouteData, busRouteData, trainRouteData, flightRouteData } from '../data';
import '../../../../styles/HowToReach.css';
import PropTypes from 'prop-types';

const HowToReach = ({ heading, subHeading, customClass = '' }) => {
  return (
    <div className={`rlHowToReach ${customClass ? customClass : ''}`}>
      {heading && <h3 className="rlHowToReach__heading">{heading}</h3>}
      {subHeading && <p className="rlHowToReach__subheading">{subHeading}</p>}
      <ContentBox>
        <RouteCarousel
          iconUrl={`kumbhMelaCabIcon`}
          heading="Top routes by Cab"
          viewMoreCta="View more routes"
          moreRoutesUrl={'https://www.makemytrip.com/cabs'}
        >
          <CabRoute data={cabRouteData} />
        </RouteCarousel>
        <RouteCarousel
          iconUrl="kumbhMelaBusIcon"
          heading="Top routes by Bus"
          viewMoreCta="View more routes"
          moreRoutesUrl={'https://www.makemytrip.com/bus-tickets/'}
        >
          <BusRoute data={busRouteData} />
        </RouteCarousel>
        <RouteCarousel
          iconUrl="kumbhMelaTrainIcon"
          heading="Top routes by Trains"
          viewMoreCta="View more routes"
          moreRoutesUrl={'https://www.makemytrip.com/railways/'}
        >
          <TrainRoute data={trainRouteData} />
        </RouteCarousel>
        <RouteCarousel
          iconUrl="kumbhMelaFlightIcon"
          heading="Top routes by Flights"
          viewMoreCta="View more routes"
          moreRoutesUrl={'https://www.makemytrip.com/flights/'}
        >
          <FlightRoute data={flightRouteData} />
        </RouteCarousel>
      </ContentBox>
    </div>
  );
};

HowToReach.propTypes = {
  heading: PropTypes.string,
  subHeading: PropTypes.string,
  customClass: PropTypes.string
};

export default HowToReach;
